var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 41,
    viewBox: "0 0 202 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_213_1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 18.44H4.12V14.75H19.72V18.44H14.29V32H9.55V18.44ZM29.8096 27.38H26.8996V32H22.1596V14.75H30.0196C32.3996 14.75 34.2896 15.32 35.6896 16.46C37.0896 17.58 37.7896 19.13 37.7896 21.11C37.7896 22.37 37.4796 23.47 36.8596 24.41C36.2596 25.33 35.3996 26.05 34.2796 26.57L38.1196 32H33.0196L29.8096 27.38ZM33.0196 21.11C33.0196 20.25 32.7396 19.59 32.1796 19.13C31.6196 18.67 30.7896 18.44 29.6896 18.44H26.8996V23.78H29.6896C30.7896 23.78 31.6196 23.55 32.1796 23.09C32.7396 22.63 33.0196 21.97 33.0196 21.11ZM52.9863 28.58H44.9163L43.4763 32H38.8862L46.6263 14.75H51.3063L59.0763 32H54.3963L52.9863 28.58ZM51.5463 25.16L48.9663 18.92L46.3563 25.16H51.5463ZM77.2319 14.75L69.7319 32H65.0519L57.5519 14.75H62.5919L67.5119 26.48L72.5519 14.75H77.2319ZM93.325 28.37V32H79.435V14.75H92.995V18.38H84.115V21.53H91.975V24.98H84.115V28.37H93.325ZM98.2038 0.499998H105.494V26.06H121.289V32H98.2038V0.499998ZM132.367 32.33C130.527 32.33 128.867 31.95 127.387 31.19C125.927 30.41 124.777 29.34 123.937 27.98C123.097 26.62 122.677 25.09 122.677 23.39C122.677 21.69 123.097 20.16 123.937 18.8C124.777 17.42 125.927 16.35 127.387 15.59C128.867 14.81 130.527 14.42 132.367 14.42C134.207 14.42 135.857 14.81 137.317 15.59C138.797 16.35 139.957 17.42 140.797 18.8C141.637 20.16 142.057 21.69 142.057 23.39C142.057 25.09 141.637 26.62 140.797 27.98C139.957 29.34 138.797 30.41 137.317 31.19C135.857 31.95 134.207 32.33 132.367 32.33ZM132.367 28.46C133.287 28.46 134.117 28.24 134.857 27.8C135.617 27.36 136.207 26.76 136.627 26C137.047 25.22 137.257 24.35 137.257 23.39C137.257 22.41 137.047 21.54 136.627 20.78C136.207 20 135.617 19.39 134.857 18.95C134.117 18.51 133.287 18.29 132.367 18.29C131.447 18.29 130.607 18.51 129.847 18.95C129.107 19.39 128.517 20 128.077 20.78C127.657 21.54 127.447 22.41 127.447 23.39C127.447 24.35 127.657 25.22 128.077 26C128.517 26.76 129.107 27.36 129.847 27.8C130.607 28.24 131.447 28.46 132.367 28.46ZM161.958 14.75L154.458 32H149.778L142.278 14.75H147.318L152.238 26.48L157.278 14.75H161.958ZM178.052 28.37V32H164.162V14.75H177.722V18.38H168.842V21.53H176.702V24.98H168.842V28.37H178.052ZM189.155 27.38H186.245V32H181.505V14.75H189.365C191.745 14.75 193.635 15.32 195.035 16.46C196.435 17.58 197.135 19.13 197.135 21.11C197.135 22.37 196.825 23.47 196.205 24.41C195.605 25.33 194.745 26.05 193.625 26.57L197.465 32H192.365L189.155 27.38ZM192.365 21.11C192.365 20.25 192.085 19.59 191.525 19.13C190.965 18.67 190.135 18.44 189.035 18.44H186.245V23.78H189.035C190.135 23.78 190.965 23.55 191.525 23.09C192.085 22.63 192.365 21.97 192.365 21.11Z",
    fill: "#EDFF20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_213_1461",
    x: 0.119995,
    y: 0.5,
    width: 201.345,
    height: 39.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0 0.6125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_213_1461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_213_1461",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/logo-yellow.057cf6a11b091e4fa5bbd726d096b9fb.svg";
export { ForwardRef as ReactComponent };